import { render, staticRenderFns } from "./PubFirebaseDemo.vue?vue&type=template&id=449ca3fa&scoped=true&"
import script from "./PubFirebaseDemo.vue?vue&type=script&lang=js&"
export * from "./PubFirebaseDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ca3fa",
  null
  
)

export default component.exports